import { ArrowLeft } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowLeft12Line = createIcon(ArrowLeft, 12, "Line");
export const IconArrowLeft16Line = createIcon(ArrowLeft, 16, "Line");
export const IconArrowLeft20Line = createIcon(ArrowLeft, 20, "Line");
export const IconArrowLeft24Line = createIcon(ArrowLeft, 24, "Line");
export const IconArrowLeft32Line = createIcon(ArrowLeft, 32, "Line");
export const IconArrowLeft48Line = createIcon(ArrowLeft, 48, "Line");
export const IconArrowLeft64Line = createIcon(ArrowLeft, 64, "Line");
